import { MdOutlineLogout } from 'react-icons/md'
import initMatrix from '../../lib/initMatrix'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { logOut } from '../../redux/reducers/authSlice'
import logo from '../../assets/images/logo.png'

import styles from './WithoutPlan.module.scss'

const WithoutPlan = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const handleLogout = () => {
    initMatrix.logout()
    dispatch(logOut())
    navigate('/register')
  }

  return (
    <div className={styles.withoutPlanWrapper}>
      <div className={styles.leftSide}>
        <header>
          <button onClick={handleLogout}>
            <MdOutlineLogout /> logout
          </button>
        </header>
        <div>
          <h3>Welcome to the AI Mobility®</h3>
          <p>
            Welcome to the AI Mobility®. To use AI Mobility® aplication please folow the steps on
            the{' '}
            <a rel='noopener noreferrer' href='https://ai-mobility.biz/' target='_blank'>
              AI Mobility®{' '}
            </a>
            web site
          </p>
        </div>
      </div>
      <div className={styles.rightSide}>
        <div>
          <img className={styles.logo} src={logo} alt='AI Mobility' />
        </div>
      </div>
    </div>
  )
}

export default WithoutPlan
